/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES API 【企業詳細】
 * PR TIMESの企業詳細画面用のAPI
 *
 * The version of the OpenAPI document: 1.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    VerifyUserUser,
    VerifyUserUserFromJSON,
    VerifyUserUserFromJSONTyped,
    VerifyUserUserToJSON,
} from './VerifyUserUser';

/**
 * ユーザーがログインしているかどうか
 * @export
 * @interface VerifyUser
 */
export interface VerifyUser {
    /**
     * ログインしているかどうか
     * @type {boolean}
     * @memberof VerifyUser
     */
    isLogin: boolean;
    /**
     * 
     * @type {VerifyUserUser}
     * @memberof VerifyUser
     */
    user?: VerifyUserUser | null;
}

export function VerifyUserFromJSON(json: any): VerifyUser {
    return VerifyUserFromJSONTyped(json, false);
}

export function VerifyUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): VerifyUser {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'isLogin': json['is_login'],
        'user': !exists(json, 'user') ? undefined : VerifyUserUserFromJSON(json['user']),
    };
}

export function VerifyUserToJSON(value?: VerifyUser | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'is_login': value.isLogin,
        'user': VerifyUserUserToJSON(value.user),
    };
}

